import { CustomButton } from 'components/shared/CustomButton';
import { HelperConstant } from '../../helpers/HelperConstant';
import { IOrderOtpView } from 'models/OrderOtpView.Model';
import React, { InputHTMLAttributes, useEffect, useState } from 'react'
import OtpInput from 'react-otp-input-rc-17';
import { useNavigate } from 'react-router-dom'
import { Alert, Card, CardBody, Col, Row } from 'reactstrap';
import CommonService from 'services/CommonService';
import { getPersonId } from '../../helpers/TokenHelper';


interface inputProps extends InputHTMLAttributes<HTMLInputElement> {
    encryptedOrderId: any,
}

function OTPVerification({ encryptedOrderId, ...rest }: inputProps) {
    const navigate = useNavigate();

    const [OTP, setOTP] = useState("");
    const [otpData, setOtpData] = useState<IOrderOtpView>();
    const [successToast, setSuccessToast] = useState(false);
    const [dangerToast, setDangerToast] = useState(false);
    const [counter, setCounter] = useState(0);
    const [isResendOTP, setIsResendOTP] = useState(false);
    const [enableClick, setEnableClick] = useState(true)

    const handleChange = (otp: any) => {
        setOTP(otp);
        setDangerToast(false)
    }
    const timersetting = () => {
        counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
    }


    const getResendButton = () => {
        if (counter > 0) {
            return "text-dofy"
        }
        else {
            return "text-underline"
        }
    }

    const getResendButtonHide = () => {
        if (counter === 0) {
            return "text-dofy"
        }
        else {
            return "text-underline";
        }
    }

    const GetOtp = (orderId: number, type: "OTP" | "resendOTP") => {
        setEnableClick(false);
        if (type === "OTP") {
            setIsResendOTP(true);
        }
        CommonService.postWithSingleParam("sell", "GetOrderOTP", orderId).then(res => {
            if (res.status === 200) {
                setCounter(HelperConstant.otpVerificationTime.timer)
                setOtpData(res.data);
                timersetting();
                setEnableClick(true);
            }
        }).catch(exception => console.log(exception))
    }
    const SubmitOrderOtp = () => {
        const Data = {
            OrderId: 0,
            personId: otpData?.personId,
            password: OTP,
            emailTemplateId: otpData?.emailTemplateId
        };
        CommonService.postWithFormDataWithQueryParam('sell', 'ValidateOrderOTP', Data, "encryptedOrderId", encryptedOrderId, "application/json").then(res => {
            if (res.status === 200) {
                if (res.data === true) {
                    setSuccessToast(true);
                    getResendButton();
                    navigate(`/success-screen/${encryptedOrderId}`)
                }
                else {
                    setDangerToast(true);
                }
            }
        }).catch(ex => console.log(ex))
    }
    useEffect(() => {
        timersetting();
    }, [counter])
    useEffect(() => {
        GetOtp(encryptedOrderId, "OTP")
    }, []);


    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Row className="justify-content-center mt-lg-0">
                        <Col xl={5} sm={8}>
                            <div className="text-center">
                                <Row className="justify-content-center">
                                    <Col lg={10}>
                                        {dangerToast &&
                                            <div className='mt-3'>
                                                <Alert
                                                    color="warning"
                                                    className="fade show"
                                                    role="alert"
                                                >
                                                    <i className="mdi mdi-alert-outline me-2"></i>
                                                    Invalid OTP
                                                </Alert>
                                            </div>}
                                        <p className="fw-semibold font-size-15 text-center">OTP Verification</p>
                                        <OtpInput
                                            isInputNum
                                            isInputSecure
                                            value={OTP}
                                            onChange={handleChange}
                                            numInputs={6}
                                            className="os_Input-align"
                                        />
                                        <div className='my-3'>
                                            <CustomButton type={'button'} btnClassName={'btn-success'} iconClasssName={undefined} name={'Verify'} disabled={counter === 0} onClick={() => SubmitOrderOtp()} />
                                        </div>
                                        {(isResendOTP) &&
                                            <div className="mt-3 d-flex justify-content-center">
                                                {counter == 0 && enableClick ?
                                                    < p onClick={() => GetOtp(encryptedOrderId, "resendOTP")} className={`${getResendButton()} cursor-pointer m-0`} >Resend OTP</p>
                                                    :
                                                    <p className={`${getResendButtonHide()} m-0`}>Resend OTP</p>}
                                            </div>
                                        }
                                        <div className="mt-2 text-center">
                                            <p className="text-info font-size-12">Resend OTP in Seconds : {counter}</p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>


        </React.Fragment >
    )
}

export default OTPVerification
